<template>
  <b-modal
    id="emailUpdateModal"
    modal-class="client-details-modal"
    centered
    size="lg"
    hide-footer
    :visible="isOpen"
    @hidden="closeModal"
    @hide="closeModal"
  >
    <template #modal-header style="border-bottom: 0px">
      <div class="view-clients-header">
        <b-button variant="close-btn close-option" @click="closeModal">
          <i class="fas fa-times"></i>
        </b-button>
      </div>
    </template>
    <b-container fluid>
      <div class="view-clients-modal-content">
        <h6>Edit Email Information</h6>
        <div class="addMessage-form">
          <ValidationObserver ref="observer" v-slot="{ handleSubmit, invalid }">
            <form
              @submit.stop.prevent="handleSubmit(updateEmail)"
              ref="updateEmailContainer"
            >
              <div>
                <div class="form-group row p-0 m-0">
                  <div class="col-md-12 p-0">
                    <input-text
                      :rules="{ required: true, email: true }"
                      labelFor="email"
                      labelName="Email"
                      inputName="email"
                      inputType="email"
                      :vmodel.sync="form.new_email"
                      class="input-fld p-0"
                    />
                  </div>

                  <div class="col-xxl-12 col-md-12 mb-3 p-0">
                    <div class="row justify-content-md-center">
                      <div class="col-xxl-5 mb-4">
                        <b-button class="btn btn-email-send custom-update-btn"  type="submit" :disabled="isUpdating">
                          <template v-if="isUpdating"> Updating... </template>
                          <template v-else :disabled="invalid"> Update </template>
                        </b-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </b-container>
  </b-modal>
</template>

<script>
import axios from "axios";
import Helper from "@/resource/Helper";

export default {
  name: "EmailUpdateModal",
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    memberData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      form: {
        new_email: "",
        user_id: null
      },
      isUpdating: false
    };
  },
  watch: {
    isOpen(val) {
      if (val && this.memberData) {
        this.form.new_email = this.memberData.email || "";
        this.form.user_id = this.memberData.user_id | this.memberData.id;
      }
    },
    memberData: {
    immediate: true,
    handler(newVal) {
      if (newVal) {
        this.form.new_email = newVal.email || "";
        this.form.user_id = newVal.user_id || newVal.id;
      }
    }
  }
  },
  mounted() {
    if (this.memberData) {
      this.form.new_email = this.memberData.email || "";
      console.log(this.form.new_email);
      this.form.user_id = this.memberData.user_id || this.memberData.id;
      console.log(this.form.user_id);
    }
    
  },
  methods: {
    reset() {
      this.form = {
        new_email: "",
        user_id: null
      };
      this.$refs.observer.reset();
    },
    closeModal() {
      this.reset();
      this.$emit("close");
    },
    updateEmail() {
    if (!this.form.user_id) {
    this.$notify("User ID is missing", "error");
    return;
  }
  const url = process.env.VUE_APP_API_URL_V2 + "change-groupmember-email";
  this.isUpdating = true;
  
  let loader = this.$loading.show({
    container: this.$refs.updateEmailContainer,
  });
  
  // Correct payload structure
  const payload = {
    new_email: this.form.new_email,
    user_id: this.form.user_id
  };
  
  axios.post(url, payload)
    .then((res) => {
      this.$notify(res.data.message || "Email updated successfully");
      this.$emit("reloadInfo");
      this.memberData.email = this.form.new_email;
      this.memberData.is_email_valid = true;
      this.closeModal();
    })
    .catch((err) => {
      const errorMsg = err.response?.data?.message || "Failed to update email";
      this.$notify(errorMsg, "error");
      // Log detailed error for debugging
      console.error("Email update error:", {
        error: err.response?.data,
        payload: payload
      });
    })
    .finally(() => {
      this.isUpdating = false;
      loader.hide();
    });
}
  }
};
</script>

<style scoped>
.custom-update-btn {
  background-color: #1392b8 !important; /* or any color you want */
  color: white;
  border: none;
}

.custom-update-btn:hover {
  background-color: #1392b8;
}
</style>